import styled from 'styled-components'

export const Container = styled.div`
  max-width: calc(${props => props.theme.maxWidth} + 120px);
  margin: 0 auto;
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};

  > div {
    max-width: ${props => props.theme.maxWidth};
    margin: 0 auto;
    padding: 20px 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
  }

  a {
    color: ${props => props.theme.palette.general.greyDark};
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
`

export const DefaultBreadcrumbItem = styled.li`
  display: flex;
  font-size: 14px;
  color: ${props => props.theme.palette.general.greyDark};

  &::after {
    content: '/';
    margin: 0 5px;
  }

  &:last-child {
    &::after {
      display: none;
    }
  }
`
